export const blockIconsMapsEmergencyNew = (
	<span className='material-symbols-outlined'>emergency</span>
);
